import { render, staticRenderFns } from "./EditBanner.vue?vue&type=template&id=3a35e0e8"
import script from "./EditBanner.vue?vue&type=script&lang=ts"
export * from "./EditBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports